
import React from "react";
import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import Icon from "@/components/ui/icon";

interface FeedbackButtonProps {
  className?: string;
  variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link";
  size?: "default" | "sm" | "lg" | "icon";
}

const FeedbackButton = ({ 
  className, 
  variant = "ghost", 
  size = "icon" 
}: FeedbackButtonProps) => {
  const handleFeedbackClick = () => {
    // Open the Typeform feedback form in a new tab
    window.open("https://form.typeform.com/to/kcI0cE15", "_blank");
    toast.success("Thank you for sharing your feedback!");
  };

  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      onClick={handleFeedbackClick}
      aria-label="Provide Feedback"
    >
      {size === "icon" ? (
        <Icon icon={MessageSquare} size={20} />
      ) : (
        <>
          <Icon icon={MessageSquare} className="mr-2" size={16} />
          <span>Feedback</span>
        </>
      )}
    </Button>
  );
};

export default FeedbackButton;
